// extracted by mini-css-extract-plugin
module.exports = {"padlock":"style_padlock__2Qmyq"};